(function () {
  "use strict";

const maker = document.querySelector(".maker");
      const shell = document.querySelector(".jp-tattoo-maker-shell");
      const statusText = document.querySelector(".status-text");
      const railButtons = Array.from(document.querySelectorAll(".rail button"));
      const mobileButtons = Array.from(document.querySelectorAll(".mobile-tabs button"));
      const fileInput = document.querySelector(".file-input");
      const uploadPreview = document.querySelector(".sample-upload");
      const textObject = document.querySelector(".text-object");
      const textInput = document.querySelector(".text-input");
      const textFontSelects = Array.from(document.querySelectorAll(".text-font-select"));
      const fontPreview = document.querySelector(".font-preview");
      const paper = document.querySelector(".paper");
      const drawingLayer = document.querySelector(".drawing-layer");
      const drawingContext = drawingLayer.getContext("2d");
      const selectionBox = document.querySelector(".selection-box");
      const modal = document.querySelector(".modal-backdrop");
      const previewPaper = document.querySelector(".preview-paper");
      const previewTitle = document.querySelector(".preview-title");
      const previewMeta = document.querySelector(".preview-meta");
      const cartFeedback = document.querySelector(".cart-feedback");
      const toast = document.querySelector(".toast");
      const layerImage = document.querySelector(".layer-image");
      const layerText = document.querySelector(".layer-text");
      const layerDrawing = document.querySelector(".layer-drawing");
      const exportCanvas = document.querySelector(".export-canvas");
      const imageEditCanvas = document.createElement("canvas");
      const imageEditContext = imageEditCanvas.getContext("2d");
      const productSizeSelects = Array.from(document.querySelectorAll(".product-size-select"));
      const productQuantitySelects = Array.from(document.querySelectorAll(".product-quantity-select"));
      const productSizeLabels = Array.from(document.querySelectorAll("[data-product-size-label]"));
      const productQuantityLabels = Array.from(document.querySelectorAll("[data-product-quantity-label]"));
      const productPriceLabels = Array.from(document.querySelectorAll("[data-product-price-label]"));
      const productVariantLabels = Array.from(document.querySelectorAll("[data-product-variant-label]"));
      const productSizeMark = document.querySelector("[data-product-size-mark]");
      const contextLabel = document.querySelector("[data-context-label]");
      const contextTitle = document.querySelector("[data-context-title]");
      const contextCopy = document.querySelector("[data-context-copy]");
      const contextNotice = document.querySelector("[data-context-notice]");
      const contextActionTitle = document.querySelector("[data-context-action-title]");
      const mobileContextTitle = document.querySelector("[data-mobile-context-title]");
      const mobileContextMeta = document.querySelector("[data-mobile-context-meta]");
      const mobileProductSummary = document.querySelector("[data-mobile-product-summary]");
      const mobileLayerSummary = document.querySelector("[data-mobile-layer-summary]");
      const mobileDrawerToggle = document.querySelector(".mobile-drawer-toggle");
      const mobileDrawerArrow = document.querySelector(".mobile-drawer-toggle .drawer-arrow");
      const brushSizeInputs = Array.from(document.querySelectorAll(".control-brush-size"));
      const brushSizeValues = Array.from(document.querySelectorAll(".brush-size-value"));
      const brushOptions = Array.from(document.querySelectorAll(".brush-option"));
      const labels = {
        empty: "Blank canvas, upload path ready",
        clean: "Clean upload, ready to adjust",
        optimize: "Needs cleanup before save",
        warning: "Reference image, upload cleaner design or continue manually",
        ready: "Design saved, cart path ready"
      };
      const embeddedProductConfig = (() => {
        const node = document.querySelector("[data-jp-tattoo-maker-config]");
        if (!node) return {};
        try {
          return JSON.parse(node.textContent || "{}");
        } catch (error) {
          console.warn("JUSTPRESS tattoo maker product config could not be parsed.", error);
          return {};
        }
      })();
      const productUrl = embeddedProductConfig.productUrl || "/products/custom-temporary-tattoo-upload-your-own-design";
      const productVariantsList = Array.isArray(embeddedProductConfig.variants) ? embeddedProductConfig.variants : [];
      let cutoutLoaderPromise = null;

      function isCutoutReady() {
        return window.JPTattooCutout && typeof window.JPTattooCutout.cleanUploadedArtwork === "function";
      }

      function loadScriptOnce(src) {
        if (!src) return Promise.reject(new Error("Missing cutout asset URL."));

        window.JPCutoutScriptPromises = window.JPCutoutScriptPromises || {};
        if (window.JPCutoutScriptPromises[src]) return window.JPCutoutScriptPromises[src];

        window.JPCutoutScriptPromises[src] = new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = src;
          script.defer = true;
          script.dataset.jpCutoutLazy = "true";
          script.onload = () => resolve();
          script.onerror = () => reject(new Error("Could not load cutout asset: " + src));
          document.head.appendChild(script);
        });

        return window.JPCutoutScriptPromises[src];
      }

      async function loadCutoutEngine() {
        if (isCutoutReady()) return true;

        const engineSrc = shell?.dataset.cutoutEngineSrc || "";
        const wrapperSrc = shell?.dataset.cutoutWrapperSrc || "";
        if (!engineSrc || !wrapperSrc) return false;

        if (!cutoutLoaderPromise) {
          cutoutLoaderPromise = loadScriptOnce(engineSrc)
            .then(() => loadScriptOnce(wrapperSrc))
            .then(() => isCutoutReady())
            .catch((error) => {
              console.warn("JUSTPRESS tattoo maker lazy cutout load failed.", error);
              return false;
            });
        }

        return cutoutLoaderPromise;
      }

      document.body.classList.add("jp-tattoo-maker-active");

      function uniqueBy(list, keyFn) {
        const seen = new Set();
        return list.filter((item) => {
          const key = keyFn(item);
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      }

      function parseSizeLabel(label) {
        const text = String(label || "").trim();
        const match = text.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*cm/i);
        const width = match ? Number(match[1]) : 2;
        const height = match ? Number(match[2]) : width;
        return {
          label: text || "2x2cm | 0.8 x 0.8 in",
          short: match ? (match[1] + "x" + match[2] + "cm") : (text || "2x2cm"),
          width,
          height
        };
      }

      function variantSize(variant) {
        return variant.option1 || (Array.isArray(variant.options) ? variant.options[0] : "") || "";
      }

      function variantQuantity(variant) {
        return variant.option2 || (Array.isArray(variant.options) ? variant.options[1] : "") || "1 Print";
      }

      const productSizes = uniqueBy(productVariantsList.map((variant) => parseSizeLabel(variantSize(variant))), (size) => size.label);
      const productQuantities = uniqueBy(productVariantsList.map((variant) => String(variantQuantity(variant) || "1 Print")), (quantity) => quantity);
      const productVariants = {};

      productVariantsList.forEach((variant) => {
        const size = variantSize(variant);
        const quantity = variantQuantity(variant);
        if (!size || !quantity) return;
        productVariants[size + " || " + quantity] = {
          id: String(variant.id || ""),
          price: Number(variant.price),
          available: variant.available !== false
        };
      });

      if (!productSizes.length) productSizes.push(parseSizeLabel("2x2cm | 0.8 x 0.8 in"));
      if (!productQuantities.length) productQuantities.push("1 Print");

      const productConfig = {
        size: productSizes[0],
        quantity: productQuantities[0]
      };
      const textFontMap = {
        system: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif',
        minimal: '"Helvetica Neue", Arial, sans-serif',
        serif: 'Georgia, "Times New Roman", serif',
        script: '"Brush Script MT", "Segoe Script", cursive',
        handwritten: '"Segoe Print", "Bradley Hand ITC", cursive',
        gothic: '"Arial Black", Impact, sans-serif',
        marker: '"Comic Sans MS", "Trebuchet MS", cursive',
        stencil: 'Impact, "Arial Black", sans-serif',
        mono: '"Courier New", Consolas, monospace',
        tattoo: '"Copperplate Gothic Light", "Cinzel", Georgia, serif'
      };
      const transforms = {
        image: { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1 },
        text: { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1 },
        drawing: { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1 }
      };
      let selectedObject = "image";
      let selectedTextFont = "system";
      let lastOriginalImageSrc = "";
      let cartRequestInFlight = false;
      let cartAddedForCurrentDesign = false;
      let uploadRequestId = 0;
      maker.dataset.mobileMode = maker.dataset.mobileMode || (window.innerWidth <= 900 ? "size" : "upload");
      maker.dataset.drawer = maker.dataset.drawer || "expanded";
      let drawingPointer = null;
      let eraserPointer = null;
      let historyStack = [];
      let historyIndex = -1;
      let isRestoringHistory = false;
      let toastTimer;
      let drawerPulseTimer = 0;
      let pointerState = null;
      const gesturePointers = new Map();
      let gestureState = null;
      const eraserBrush = { size: 34 };
      const drawingBrush = { size: 4, type: "fine" };
      const drawingBrushes = {
        fine: { label: "Fine", alpha: 1, multiplier: 1, color: "#1d1d1f" },
        needle: { label: "Needle", alpha: 1, multiplier: 0.55, color: "#111827" },
        marker: { label: "Marker", alpha: 0.9, multiplier: 1.8, color: "#111827" },
        soft: { label: "Soft", alpha: 0.42, multiplier: 2.5, color: "#1d1d1f" }
      };
      let controlSyncFrame = 0;
      let imagePreviewSyncFrame = 0;
      let lastImagePreviewSync = 0;

      function syncMobileGlobalTop() {
        if (!shell) return;
        const rect = shell.getBoundingClientRect();
        const viewportHeight = Math.round(window.visualViewport?.height || window.innerHeight);
        const nextTop = Math.max(12, Math.min(viewportHeight - 72, rect.top + 12));
        shell.style.setProperty("--jp-mobile-global-top", `${Math.round(nextTop)}px`);
      }

      function syncMakerViewportHeight() {
        if (!maker || !shell) return;
        const top = Math.max(0, shell.getBoundingClientRect().top);
        const previewBar = document.getElementById("PBarNextFrameWrapper");
        const previewBarRect = previewBar ? previewBar.getBoundingClientRect() : null;
        const previewBarStyle = previewBar ? window.getComputedStyle(previewBar) : null;
        const bottomOffset = previewBarRect && previewBarStyle && previewBarStyle.display !== "none" && previewBarStyle.visibility !== "hidden" && previewBarRect.height > 0
          ? Math.round(previewBarRect.height)
          : 0;
        shell.style.setProperty("--jp-bottom-offset", `${bottomOffset}px`);
        const viewportHeight = Math.round(window.visualViewport?.height || window.innerHeight);
        const visibleAvailable = viewportHeight - top - bottomOffset;
        const focusMobile = window.innerWidth <= 900 && maker.dataset.focus === "true";
        const mobileBaseHeight = focusMobile
          ? Math.max(360, visibleAvailable)
          : Math.min(
              viewportHeight,
              Math.max(640, Math.round(viewportHeight * 0.88))
            );
        const desktopBaseHeight = Math.min(
          viewportHeight,
          Math.max(680, Math.round(viewportHeight * 0.82))
        );
        const minHeight = window.innerWidth <= 900 ? mobileBaseHeight : desktopBaseHeight;
        const available = focusMobile ? Math.max(360, visibleAvailable) : Math.max(minHeight, visibleAvailable);
        maker.style.setProperty("--jp-maker-height", `${Math.round(available)}px`);
        syncMobileGlobalTop();
      }

      function focusEditorViewport() {
        if (!shell) return;
        const targetTop = Math.max(0, Math.round(shell.getBoundingClientRect().top + window.scrollY));
        window.requestAnimationFrame(() => {
          window.scrollTo({ top: targetTop, behavior: "smooth" });
          window.setTimeout(syncMakerViewportHeight, 260);
        });
      }

      function syncMobileDockVisibility() {
        if (!maker || window.innerWidth > 900) {
          maker?.classList.remove("is-mobile-dock-hidden");
          return;
        }
        const rect = maker.getBoundingClientRect();
        const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
        maker.classList.toggle("is-mobile-dock-hidden", visibleHeight < 180);
        syncMobileGlobalTop();
      }

      syncMakerViewportHeight();
      syncMobileDockVisibility();
      requestAnimationFrame(syncMakerViewportHeight);
      [100, 300, 700, 1400, 2400].forEach((delay) => {
        window.setTimeout(syncMakerViewportHeight, delay);
        window.setTimeout(syncMobileDockVisibility, delay);
      });
      window.addEventListener("load", () => {
        syncMakerViewportHeight();
        syncMobileDockVisibility();
      }, { passive: true });
      window.addEventListener("resize", () => {
        syncMakerViewportHeight();
        syncMobileDockVisibility();
        updateProductConfig();
      }, { passive: true });
      window.addEventListener("scroll", () => {
        syncMobileDockVisibility();
      }, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", () => {
          syncMakerViewportHeight();
          syncMobileDockVisibility();
        }, { passive: true });
      }
      if ("ResizeObserver" in window) {
        const heightObserver = new ResizeObserver(syncMakerViewportHeight);
        heightObserver.observe(shell);
        heightObserver.observe(document.body);
      }

      document.querySelectorAll(".object-bar [data-action='nudge-right'], .sheet-clean [data-action='nudge-right']").forEach((button) => {
        button.dataset.action = "move-mode";
        button.dataset.icon = "Move";
        button.textContent = "Drag";
      });

      function clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      function productKey(size = productConfig.size, quantity = productConfig.quantity) {
        return `${size.label} || ${quantity}`;
      }

      function selectedVariant() {
        return productVariants[productKey()] || null;
      }

      function formatMoney(cents) {
        if (!Number.isFinite(cents)) return "";
        const currency = embeddedProductConfig.currency || "USD";
        try {
          return new Intl.NumberFormat(embeddedProductConfig.locale || navigator.language || "en-US", {
            style: "currency",
            currency
          }).format(cents / 100);
        } catch (error) {
          return "$" + (cents / 100).toFixed(2);
        }
      }

      function productMeta() {
        const variant = selectedVariant();
        const price = variant ? " - " + formatMoney(variant.price) : "";
        return productConfig.size.label + " - " + productConfig.quantity + price;
      }

      function compactPrintQuantity(quantity) {
        return String(quantity || "")
          .replace(/\s+/g, " ")
          .trim()
          .replace(/\bPrints?\b/i, (match) => match.toLowerCase());
      }

      function mobileProductMeta() {
        const variant = selectedVariant();
        const price = variant ? " \u00b7 " + formatMoney(variant.price) : "";
        return productConfig.size.short + " \u00b7 " + compactPrintQuantity(productConfig.quantity) + price;
      }

      function fillProductOptions() {
        productSizeSelects.forEach((select) => {
          select.innerHTML = "";
          productSizes.forEach((size) => {
            const option = document.createElement("option");
            option.value = size.label;
            option.textContent = size.label;
            select.appendChild(option);
          });
        });

        productQuantitySelects.forEach((select) => {
          select.innerHTML = "";
          productQuantities.forEach((quantity) => {
            const option = document.createElement("option");
            option.value = quantity;
            option.textContent = quantity;
            select.appendChild(option);
          });
        });
      }

      function updateProductConfig({ notify = false } = {}) {
        const ratio = productConfig.size.width / productConfig.size.height;
        const mobileDisplayRatioLimit = 1.8;
        const displayRatio = window.innerWidth <= 900 ? Math.min(ratio, mobileDisplayRatioLimit) : ratio;
        const displayWidth = ratio > displayRatio ? productConfig.size.height * displayRatio : productConfig.size.width;
        const aspect = `${displayWidth} / ${productConfig.size.height}`;
        const variant = selectedVariant();
        const priceLabel = variant ? formatMoney(variant.price) : "Unavailable";
        const variantLabel = variant ? "Selected product" : "Product unavailable";
        maker.style.setProperty("--paper-aspect", aspect);
        maker.style.setProperty("--paper-ratio", displayRatio.toFixed(4));
        maker.dataset.productRatio = ratio.toFixed(4);
        maker.dataset.displayRatio = displayRatio.toFixed(4);
        maker.dataset.variantId = variant ? variant.id : "";

        productSizeSelects.forEach((select) => {
          select.value = productConfig.size.label;
        });
        productQuantitySelects.forEach((select) => {
          select.value = productConfig.quantity;
        });
        productSizeLabels.forEach((node) => {
          node.textContent = productConfig.size.label;
        });
        productQuantityLabels.forEach((node) => {
          node.textContent = productConfig.quantity;
        });
        productPriceLabels.forEach((node) => {
          node.textContent = priceLabel;
        });
        productVariantLabels.forEach((node) => {
          node.textContent = variantLabel;
        });
        if (mobileProductSummary) mobileProductSummary.textContent = mobileProductMeta();
        if (productSizeMark) productSizeMark.textContent = productConfig.size.short;

        if (exportCanvas) {
          exportCanvas.width = 1200;
          exportCanvas.height = Math.round(1200 / ratio);
        }

        if (notify) showToast(`Selected ${productConfig.size.short}, ${productConfig.quantity}`);
      }

      function isQaSampleState() {
        return false;
      }

      function hasImageContent() {
        return maker.dataset.uploaded === "true" || isQaSampleState();
      }

      function hasDesignContent() {
        return hasImageContent() || maker.dataset.hasText === "true" || maker.dataset.hasDrawing === "true";
      }

      function requireDesignContent(actionLabel) {
        if (hasDesignContent()) return true;
        showToast(`${actionLabel} after uploading artwork or adding text`);
        return false;
      }

      function setState(state) {
        maker.dataset.state = state;
        statusText.textContent = labels[state];

        if (!maker.dataset.mobileMode) maker.dataset.mobileMode = state === "empty" ? "size" : "move";
        updateMobileActionState();
        updateSelectionBox();
        updateActionAvailability();
      }

      function setMode(mode) {
        railButtons.forEach((button) => {
          button.classList.toggle("is-active", button.dataset.action === mode);
        });
      }

      function mobileActionKey(action) {
        if (action === "preview") return "review";
        if (action === "size") return "size";
        return action;
      }

      function normalizeMobileTabs() {
        document.querySelectorAll(".mobile-tabs [data-action='draw']").forEach((button) => {
          button.hidden = false;
          button.removeAttribute("aria-hidden");
          button.tabIndex = 0;
          button.classList.remove("is-active");
        });
      }

      function updateMobileActionState() {
        normalizeMobileTabs();
        const activeMode = maker.dataset.mobileMode || "upload";
        mobileButtons.forEach((button) => {
          const key = mobileActionKey(button.dataset.action);
          button.classList.toggle("is-active", key === activeMode || button.dataset.action === activeMode);
        });
      }

      function updateMobileDrawerToggle() {
        if (!mobileDrawerToggle) return;
        const collapsed = maker.dataset.drawer === "collapsed";
        mobileDrawerToggle.classList.toggle("is-collapsed", collapsed);
        mobileDrawerToggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
        mobileDrawerToggle.setAttribute("aria-label", collapsed ? "Expand editor controls" : "Collapse editor controls");
      }

      function setMobileDrawer(collapsed, options = {}) {
        maker.dataset.drawer = collapsed ? "collapsed" : "expanded";
        if (collapsed && maker.dataset.mobileMode === "text") {
          maker.dataset.textOpen = "false";
          maker.dataset.mobileMode = hasDesignContent() ? "move" : "upload";
          updateMobileActionState();
        }
        updateMobileDrawerToggle();
        syncMakerViewportHeight();
        updateSelectionBox();
        if (options.notify) showToast(collapsed ? "Controls collapsed" : "Controls expanded");
      }

      function toggleMobileDrawer() {
        setMobileDrawer(maker.dataset.drawer !== "collapsed", { notify: true });
      }

      function pulseMobileDrawerArrow() {
        if (!mobileDrawerArrow || typeof mobileDrawerArrow.animate !== "function") return;
        const collapsed = maker.dataset.drawer === "collapsed";
        const landscapeFocus = window.innerWidth <= 900
          && maker.dataset.focus === "true"
          && window.matchMedia("(orientation: landscape)").matches;
        const base = landscapeFocus ? "translateX(0)" : "translateY(0)";
        const active = landscapeFocus
          ? (collapsed ? "translateX(-3px)" : "translateX(3px)")
          : (collapsed ? "translateY(-3px)" : "translateY(3px)");
        mobileDrawerArrow.animate(
          [
            { transform: base, opacity: 0.56 },
            { transform: active, opacity: 1 },
            { transform: base, opacity: 0.72 }
          ],
          { duration: 950, easing: "cubic-bezier(.2,.7,.2,1)" }
        );
      }

      function scheduleDrawerCue() {
        window.clearInterval(drawerPulseTimer);
        drawerPulseTimer = window.setInterval(pulseMobileDrawerArrow, 2800);
        pulseMobileDrawerArrow();
      }

      function setMobileMode(mode) {
        const nextMode = mode || "upload";
        maker.dataset.mobileMode = nextMode;
        maker.dataset.textOpen = nextMode === "text" ? "true" : "false";
        maker.dataset.mobileProductOpen = nextMode === "size" ? "true" : "false";
        if (["size", "text", "draw"].includes(nextMode) && window.innerWidth <= 900) {
          maker.dataset.drawer = "expanded";
        }
        if (nextMode !== "draw") maker.dataset.drawing = "false";
        if (nextMode !== "move") maker.dataset.erasing = "false";
        updateMobileActionState();
        updateMobileDrawerToggle();
      }

      function showToast(message) {
        toast.textContent = message;
        toast.classList.add("is-visible");
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 2400);
      }

      function designKind() {
        const hasImage = hasImageContent();
        const hasText = maker.dataset.hasText === "true";
        const hasDrawing = maker.dataset.hasDrawing === "true";
        if (hasImage && (hasText || hasDrawing)) return "mixed";
        if (hasImage) return maker.dataset.cleaned === "true" ? "cleaned-image" : "image";
        if (hasText && hasDrawing) return "text-drawing";
        if (hasText) return "text";
        if (hasDrawing) return "drawing";
        return "empty";
      }

      function updateContextPanel() {
        const kind = designKind();
        const layerNames = { image: "Artwork selected", text: "Text selected", drawing: "Handwriting selected" };
        if (mobileLayerSummary) mobileLayerSummary.textContent = hasDesignContent() ? (layerNames[selectedObject] || "Layer selected") : "Blank canvas";
        const content = {
          image: {
            label: "Artwork ready",
            title: "Artwork on canvas",
            copy: "Your uploaded design is ready to position, preview, or save.",
            notice: "Use Clean background only if the image still has a visible background.",
            action: "Next step",
            mobileTitle: "Artwork ready",
            mobileMeta: "Adjust placement"
          },
          "cleaned-image": {
            label: "Background cleaned",
            title: "Cleaned artwork",
            copy: "Background cleanup is finished. Preview the design before adding it to cart.",
            notice: "The cleanup step has already run for this image.",
            action: "Output",
            mobileTitle: "Background cleaned",
            mobileMeta: "Ready to preview"
          },
          text: {
            label: "Text design",
            title: "Text on canvas",
            copy: "Your text is placed on the tattoo canvas. Adjust position or preview the result.",
            notice: "Use Text again to change wording or choose another font.",
            action: "Output",
            mobileTitle: "Text ready",
            mobileMeta: "Edit or preview"
          },
          drawing: {
            label: "Handwriting",
            title: "Handwriting on canvas",
            copy: "Your drawing is on the canvas. Add more strokes, clear it, or preview the result.",
            notice: "Use Draw more for extra strokes or Clear to remove handwriting.",
            action: "Output",
            mobileTitle: "Handwriting ready",
            mobileMeta: "Draw or clear"
          },
          "text-drawing": {
            label: "Custom design",
            title: "Text and handwriting",
            copy: "Text and handwriting are both on the canvas. Check the preview before ordering.",
            notice: "Use the layer list to select which part you want to edit.",
            action: "Output",
            mobileTitle: "Layered design",
            mobileMeta: "Select a layer"
          },
          mixed: {
            label: "Custom composition",
            title: "Artwork with added details",
            copy: "Your uploaded artwork, text, or handwriting are combined on the canvas.",
            notice: "Use the layer list to select image, text, or handwriting before editing.",
            action: "Output",
            mobileTitle: "Layered design",
            mobileMeta: "Select a layer"
          },
          empty: {
            label: "No artwork yet",
            title: "Start on the canvas",
            copy: "Choose the product size, then start from the canvas with image, text, or handwriting.",
            notice: "",
            action: "Next step",
            mobileTitle: "Start design",
            mobileMeta: "Choose an input"
          }
        }[kind];

        maker.dataset.designKind = kind;
        if (contextLabel) contextLabel.textContent = content.label;
        if (contextTitle) contextTitle.textContent = content.title;
        if (contextCopy) contextCopy.textContent = content.copy;
        if (contextNotice) {
          contextNotice.textContent = content.notice;
          contextNotice.style.display = content.notice ? "" : "none";
        }
        if (contextActionTitle) contextActionTitle.textContent = content.action;
        if (mobileContextTitle) mobileContextTitle.textContent = content.mobileTitle;
        if (mobileContextMeta) mobileContextMeta.textContent = content.mobileMeta;

        document.querySelectorAll('[data-action="clean-background"]').forEach((button) => {
          const alreadyCleaned = maker.dataset.cleaned === "true";
          button.textContent = alreadyCleaned ? "Cleaned" : "Clean background";
          button.dataset.icon = alreadyCleaned ? "Done" : "Clean";
        });
      }

      function cloneTransforms() {
        return Object.fromEntries(Object.entries(transforms).map(([key, value]) => [key, { ...value }]));
      }

      function captureHistoryState() {
        return {
          state: maker.dataset.state,
          selected: selectedObject,
          uploaded: maker.dataset.uploaded || "false",
          hasText: maker.dataset.hasText || "false",
          hasDrawing: maker.dataset.hasDrawing || "false",
          cleaned: maker.dataset.cleaned || "false",
          textOpen: maker.dataset.textOpen || "false",
          drawing: maker.dataset.drawing || "false",
          erasing: maker.dataset.erasing || "false",
          uploadSrc: uploadPreview.getAttribute("src") || "",
          textContent: textObject.textContent || "",
          textInput: textInput.value || "",
          textFont: selectedTextFont,
          transforms: cloneTransforms(),
          drawingData: maker.dataset.hasDrawing === "true" && drawingLayer.width ? drawingLayer.toDataURL("image/png") : ""
        };
      }

      function updateHistoryButtons() {
        document.querySelectorAll('[data-action="undo"]').forEach((button) => {
          button.disabled = historyIndex <= 0;
          button.setAttribute("aria-disabled", historyIndex <= 0 ? "true" : "false");
        });
        document.querySelectorAll('[data-action="redo"]').forEach((button) => {
          button.disabled = historyIndex >= historyStack.length - 1;
          button.setAttribute("aria-disabled", historyIndex >= historyStack.length - 1 ? "true" : "false");
        });
      }

      function commitHistory() {
        if (isRestoringHistory) return;
        const snapshot = captureHistoryState();
        historyStack = historyStack.slice(0, historyIndex + 1);
        historyStack.push(snapshot);
        if (historyStack.length > 60) historyStack.shift();
        historyIndex = historyStack.length - 1;
        updateHistoryButtons();
      }

      function restoreHistory(snapshot) {
        if (!snapshot) return;
        isRestoringHistory = true;
        maker.dataset.uploaded = snapshot.uploaded;
        maker.dataset.hasText = snapshot.hasText;
        maker.dataset.hasDrawing = snapshot.hasDrawing;
        maker.dataset.cleaned = snapshot.cleaned || "false";
        maker.dataset.textOpen = snapshot.textOpen;
        maker.dataset.drawing = snapshot.drawing;
        maker.dataset.erasing = "false";
        selectedObject = snapshot.selected || "image";
        maker.dataset.selected = selectedObject;

        if (snapshot.uploadSrc) uploadPreview.src = snapshot.uploadSrc;
        else uploadPreview.removeAttribute("src");
        textObject.textContent = snapshot.textContent;
        textInput.value = snapshot.textInput;
        Object.keys(snapshot.transforms || {}).forEach((key) => {
          transforms[key] = { ...transforms[key], ...snapshot.transforms[key] };
        });
        applyTextFont(snapshot.textFont || "system");

        setState(snapshot.state || "empty");
        applyTransform("image");
        applyTransform("text");
        applyTransform("drawing");
        resizeDrawingLayer();
        drawingContext.clearRect(0, 0, drawingLayer.width, drawingLayer.height);

        if (snapshot.drawingData) {
          const restoredDrawing = new Image();
          restoredDrawing.onload = () => {
            const rect = paper.getBoundingClientRect();
            drawingContext.drawImage(restoredDrawing, 0, 0, rect.width, rect.height);
            configureDrawingContext();
          };
          restoredDrawing.src = snapshot.drawingData;
        }

        updateControls();
        updateSelectionBox();
        updateActionAvailability();
        isRestoringHistory = false;
        updateHistoryButtons();
      }

      function undoHistory() {
        if (historyIndex <= 0) return;
        historyIndex -= 1;
        restoreHistory(historyStack[historyIndex]);
        showToast("Undone");
      }

      function redoHistory() {
        if (historyIndex >= historyStack.length - 1) return;
        historyIndex += 1;
        restoreHistory(historyStack[historyIndex]);
        showToast("Redone");
      }

      function activeImage() {
        if (maker.dataset.uploaded === "true") return uploadPreview;
        if (!isQaSampleState()) return null;
        if (maker.dataset.state === "optimize") return document.querySelector(".sample-optimize");
        if (maker.dataset.state === "warning") return document.querySelector(".sample-warning");
        return document.querySelector(".sample-clean");
      }

      function selectedElement() {
        if (selectedObject === "text") return textObject;
        if (selectedObject === "drawing") return drawingLayer;
        return activeImage();
      }

      function updateSelectionBox() {
        const value = transforms[selectedObject] || transforms.image;
        const isText = selectedObject === "text";
        const isDrawing = selectedObject === "drawing";
        const imageSizes = {
          clean: ["64%", "72%"],
          optimize: ["68%", "74%"],
          warning: ["76%", "78%"],
          ready: ["64%", "72%"]
        };
        const size = isText
          ? ["min(420px, 76%)", "74px"]
          : isDrawing
            ? ["82%", "82%"]
            : (imageSizes[maker.dataset.state] || imageSizes.clean);

        maker.dataset.selected = selectedObject;
        selectionBox.style.setProperty("--x", `${value.x}px`);
        selectionBox.style.setProperty("--y", `${value.y}px`);
        selectionBox.style.setProperty("--scale", value.scale);
        selectionBox.style.setProperty("--rotate", `${value.rotate}deg`);
        selectionBox.style.setProperty("--selection-width", size[0]);
        selectionBox.style.setProperty("--selection-height", size[1]);
      }

      function applyTransform(type = selectedObject) {
        const target = type === "text"
          ? textObject
          : type === "drawing"
            ? drawingLayer
            : document.querySelectorAll(".sample-art");
        const value = transforms[type];
        const nodes = target instanceof NodeList ? Array.from(target) : [target];

        nodes.forEach((node) => {
          if (!node) return;
          node.style.setProperty("--x", `${value.x}px`);
          node.style.setProperty("--y", `${value.y}px`);
          node.style.setProperty("--scale", value.scale);
          node.style.setProperty("--rotate", `${value.rotate}deg`);
          node.style.setProperty("--opacity", value.opacity);
        });
        if (type === selectedObject) updateSelectionBox();
      }

      function updateControls() {
        const value = transforms[selectedObject] || transforms.image;
        document.querySelectorAll(".control-scale").forEach((input) => input.value = Math.round(value.scale * 100));
        document.querySelectorAll(".control-rotate").forEach((input) => input.value = value.rotate);
        document.querySelectorAll(".control-opacity").forEach((input) => input.value = Math.round(value.opacity * 100));
        document.querySelectorAll(".control-eraser").forEach((input) => input.value = eraserBrush.size);
        brushSizeInputs.forEach((input) => input.value = drawingBrush.size);
        document.querySelectorAll(".scale-value").forEach((node) => node.textContent = `${Math.round(value.scale * 100)}%`);
        document.querySelectorAll(".rotate-value").forEach((node) => node.textContent = `${value.rotate} deg`);
        document.querySelectorAll(".opacity-value").forEach((node) => node.textContent = `${Math.round(value.opacity * 100)}%`);
        document.querySelectorAll(".eraser-value").forEach((node) => node.textContent = `${eraserBrush.size}px`);
        brushSizeValues.forEach((node) => node.textContent = `${drawingBrush.size}px`);
        brushOptions.forEach((button) => {
          const active = button.dataset.brush === drawingBrush.type;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-pressed", active ? "true" : "false");
        });
        document.querySelectorAll('[data-action="focus-canvas"]').forEach((button) => {
          const active = maker.dataset.focus === "true";
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-pressed", active ? "true" : "false");
          if (button.classList.contains("focus-toggle")) {
            button.textContent = active ? "Exit landscape" : "Landscape edit";
          }
          if (button.classList.contains("mobile-landscape-toggle")) {
            button.setAttribute("aria-label", active ? "Exit landscape edit" : "Landscape edit");
            const label = button.querySelector(".landscape-label");
            if (label) label.textContent = active ? "Exit" : "Wide";
          }
        });
        layerImage.classList.toggle("is-active", selectedObject === "image");
        layerText.classList.toggle("is-active", selectedObject === "text");
        layerDrawing.classList.toggle("is-active", selectedObject === "drawing");
        layerText.disabled = maker.dataset.hasText !== "true";
        layerDrawing.disabled = maker.dataset.hasDrawing !== "true";
        updateMobileDrawerToggle();
        updateActionAvailability();
      }

      function scheduleControlSync() {
        if (controlSyncFrame) return;
        controlSyncFrame = requestAnimationFrame(() => {
          controlSyncFrame = 0;
          updateControls();
        });
      }

      function updateActionAvailability() {
        const hasContent = hasDesignContent();
        maker.dataset.hasContent = hasContent ? "true" : "false";

        document.querySelectorAll('[data-action="save"]').forEach((button) => {
          button.disabled = !hasContent;
        });

        document.querySelectorAll('[data-action="preview"], [data-action="cart"]').forEach((button) => {
          const blocked = !hasContent;
          button.disabled = false;
          button.classList.toggle("is-soft-disabled", blocked);
          button.setAttribute("aria-disabled", blocked ? "true" : "false");
          button.title = blocked ? "Add artwork or text first" : "";
        });

        document.querySelectorAll('[data-action="center-selected"]').forEach((button) => {
          button.disabled = !hasContent;
        });

        document.querySelectorAll('[data-action="scale-up"], [data-action="scale-down"], [data-action="delete"], [data-action="layers"]').forEach((button) => {
          button.disabled = !hasContent;
        });

        document.querySelectorAll('[data-action="clean-background"]').forEach((button) => {
          button.disabled = !hasImageContent() || maker.dataset.cleaned === "true";
        });

        document.querySelectorAll('[data-action="erase-image"]').forEach((button) => {
          button.disabled = !hasImageContent();
          button.classList.toggle("is-active", maker.dataset.erasing === "true");
        });

        document.querySelectorAll(".control-eraser").forEach((input) => {
          input.disabled = !hasImageContent();
        });

        document.querySelectorAll('[data-action="select-image"]').forEach((button) => {
          button.disabled = !hasImageContent();
        });

        document.querySelectorAll('[data-action="clear-drawing"], [data-action="select-drawing"]').forEach((button) => {
          button.disabled = maker.dataset.hasDrawing !== "true";
        });

        updateContextPanel();
        updateHistoryButtons();
      }

      function selectObject(type) {
        if (type === "text" && maker.dataset.hasText !== "true") {
          openTextInput();
          return;
        }
        if (type === "drawing" && maker.dataset.hasDrawing !== "true") {
          enableDrawingMode();
          return;
        }
        selectedObject = type;
        maker.dataset.selected = type;
        maker.dataset.drawing = type === "drawing" ? "true" : "false";
        maker.dataset.erasing = "false";
        if (type === "drawing") resizeDrawingLayer();
        updateControls();
        updateSelectionBox();
        showToast(type === "text" ? "Text layer selected" : type === "drawing" ? "Handwriting layer selected" : "Artwork layer selected");
      }

      function applyTextFont(font = selectedTextFont) {
        selectedTextFont = font;
        const fontFamily = textFontMap[font] || textFontMap.system;
        textObject.dataset.font = font;
        textObject.style.fontFamily = fontFamily;
        textInput.style.fontFamily = fontFamily;
        if (fontPreview) {
          fontPreview.style.fontFamily = fontFamily;
          fontPreview.textContent = textInput.value.trim() || textObject.textContent || "Custom tattoo";
        }
        textFontSelects.forEach((select) => {
          select.value = selectedTextFont;
        });
      }

      function currentBrush() {
        return drawingBrushes[drawingBrush.type] || drawingBrushes.fine;
      }

      function setDrawingBrush(type, options = {}) {
        if (!drawingBrushes[type]) return;
        drawingBrush.type = type;
        configureDrawingContext();
        updateControls();
        if (options.notify) showToast(`${drawingBrushes[type].label} brush selected`);
      }

      function setDrawingBrushSize(size, options = {}) {
        drawingBrush.size = clamp(Number(size) || 4, 1, 28);
        configureDrawingContext();
        updateControls();
        if (options.notify) showToast(`Brush stroke ${drawingBrush.size}px`);
      }

      function configureDrawingContext() {
        const brush = currentBrush();
        drawingContext.lineCap = "round";
        drawingContext.lineJoin = "round";
        drawingContext.globalCompositeOperation = "source-over";
        drawingContext.globalAlpha = brush.alpha;
        drawingContext.strokeStyle = brush.color;
        drawingContext.lineWidth = Math.max(1, drawingBrush.size * brush.multiplier);
      }

      function syncEditableImageCanvas() {
        if (!uploadPreview.naturalWidth || !uploadPreview.naturalHeight) return false;
        imageEditCanvas.width = uploadPreview.naturalWidth;
        imageEditCanvas.height = uploadPreview.naturalHeight;
        imageEditContext.clearRect(0, 0, imageEditCanvas.width, imageEditCanvas.height);
        imageEditContext.drawImage(uploadPreview, 0, 0, imageEditCanvas.width, imageEditCanvas.height);
        return true;
      }

      function applyEditableImageCanvas({ force = false } = {}) {
        if (!imageEditCanvas.width || !imageEditCanvas.height) return;
        const now = performance.now();
        if (!force && now - lastImagePreviewSync < 120) {
          if (!imagePreviewSyncFrame) {
            imagePreviewSyncFrame = requestAnimationFrame(() => {
              imagePreviewSyncFrame = 0;
              applyEditableImageCanvas({ force: true });
            });
          }
          return;
        }
        lastImagePreviewSync = now;
        uploadPreview.src = imageEditCanvas.toDataURL("image/png");
      }

      function copyCanvasToEditableImage(sourceCanvas) {
        if (!sourceCanvas || !sourceCanvas.width || !sourceCanvas.height) return false;
        imageEditCanvas.width = sourceCanvas.width;
        imageEditCanvas.height = sourceCanvas.height;
        imageEditContext.clearRect(0, 0, imageEditCanvas.width, imageEditCanvas.height);
        imageEditContext.drawImage(sourceCanvas, 0, 0);
        applyEditableImageCanvas();
        return true;
      }

      function enableImageEraseMode() {
        if (!hasImageContent() || !uploadPreview.naturalWidth) {
          showToast("Upload artwork before using the eraser");
          return;
        }
        syncEditableImageCanvas();
        selectedObject = "image";
        maker.dataset.selected = "image";
        maker.dataset.drawing = "false";
        maker.dataset.erasing = "true";
        setMobileMode("move");
        updateControls();
        updateSelectionBox();
        showToast("Drag over the artwork to erase");
      }

      function eraseImageAt(event) {
        if (!imageEditCanvas.width || !imageEditCanvas.height) syncEditableImageCanvas();
        const rect = uploadPreview.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const xRatio = (event.clientX - rect.left) / rect.width;
        const yRatio = (event.clientY - rect.top) / rect.height;
        if (xRatio < -0.05 || xRatio > 1.05 || yRatio < -0.05 || yRatio > 1.05) return;
        const x = clamp(xRatio, 0, 1) * imageEditCanvas.width;
        const y = clamp(yRatio, 0, 1) * imageEditCanvas.height;
        const radius = Math.max(10, (eraserBrush.size / Math.max(rect.width, 1)) * imageEditCanvas.width);
        imageEditContext.save();
        imageEditContext.globalCompositeOperation = "destination-out";
        imageEditContext.beginPath();
        imageEditContext.arc(x, y, radius, 0, Math.PI * 2);
        imageEditContext.fill();
        imageEditContext.restore();
        applyEditableImageCanvas();
      }

      function beginImageErase(event) {
        if (!hasImageContent()) return;
        syncEditableImageCanvas();
        eraserPointer = { id: event.pointerId };
        selectedObject = "image";
        maker.dataset.selected = "image";
        paper.setPointerCapture(event.pointerId);
        eraseImageAt(event);
        event.preventDefault();
        event.stopPropagation();
      }

      function moveImageErase(event) {
        if (!eraserPointer || eraserPointer.id !== event.pointerId) return;
        eraseImageAt(event);
        event.preventDefault();
        event.stopPropagation();
      }

      function endImageErase(event) {
        if (!eraserPointer || eraserPointer.id !== event.pointerId) return;
        eraserPointer = null;
        maker.dataset.cleaned = "true";
        applyEditableImageCanvas({ force: true });
        applyTransform("image");
        updateControls();
        commitHistory();
        showToast("Artwork erased");
        event.preventDefault();
        event.stopPropagation();
      }

      function resizeDrawingLayer() {
        const rect = paper.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const dpr = window.devicePixelRatio || 1;
        const nextWidth = Math.max(1, Math.round(rect.width * dpr));
        const nextHeight = Math.max(1, Math.round(rect.height * dpr));
        if (drawingLayer.width === nextWidth && drawingLayer.height === nextHeight) {
          configureDrawingContext();
          return;
        }

        const previousData = maker.dataset.hasDrawing === "true" && drawingLayer.width && drawingLayer.height
          ? drawingLayer.toDataURL("image/png")
          : "";
        drawingLayer.width = nextWidth;
        drawingLayer.height = nextHeight;
        drawingContext.setTransform(dpr, 0, 0, dpr, 0, 0);
        configureDrawingContext();

        if (previousData) {
          const previousImage = new Image();
          previousImage.onload = () => {
            drawingContext.save();
            drawingContext.globalCompositeOperation = "source-over";
            drawingContext.globalAlpha = 1;
            drawingContext.drawImage(previousImage, 0, 0, rect.width, rect.height);
            drawingContext.restore();
            configureDrawingContext();
          };
          previousImage.src = previousData;
        }
      }

      function drawingPoint(event) {
        const rect = drawingLayer.getBoundingClientRect();
        return {
          x: event.clientX - rect.left,
          y: event.clientY - rect.top
        };
      }

      function enableDrawingMode() {
        setMobileMode("draw");
        maker.dataset.drawing = "true";
        selectedObject = "drawing";
        maker.dataset.selected = "drawing";
        if (maker.dataset.state === "empty") setState("clean");
        resizeDrawingLayer();
        setMode("draw");
        updateControls();
        updateSelectionBox();
        showToast("Write directly on the canvas");
      }

      function beginDrawing(event) {
        if (event.button !== undefined && event.button !== 0) return;
        resizeDrawingLayer();
        const point = drawingPoint(event);
        drawingPointer = { id: event.pointerId, last: point };
        maker.dataset.hasDrawing = "true";
        maker.dataset.drawing = "true";
        selectedObject = "drawing";
        maker.dataset.selected = "drawing";
        drawingLayer.setPointerCapture(event.pointerId);
        configureDrawingContext();
        drawingContext.beginPath();
        drawingContext.moveTo(point.x, point.y);
        drawingContext.lineTo(point.x + 0.01, point.y + 0.01);
        drawingContext.stroke();
        updateControls();
        updateActionAvailability();
        event.preventDefault();
        event.stopPropagation();
      }

      function moveDrawing(event) {
        if (!drawingPointer || drawingPointer.id !== event.pointerId) return;
        const point = drawingPoint(event);
        configureDrawingContext();
        drawingContext.beginPath();
        drawingContext.moveTo(drawingPointer.last.x, drawingPointer.last.y);
        drawingContext.lineTo(point.x, point.y);
        drawingContext.stroke();
        drawingPointer.last = point;
        event.preventDefault();
        event.stopPropagation();
      }

      function endDrawing(event) {
        if (!drawingPointer || drawingPointer.id !== event.pointerId) return;
        drawingPointer = null;
        commitHistory();
        updateControls();
        updateSelectionBox();
        event.preventDefault();
        event.stopPropagation();
      }

      function finishDrawing() {
        if (maker.dataset.hasDrawing !== "true") {
          showToast("Draw on the canvas before finishing");
          return;
        }
        drawingPointer = null;
        maker.dataset.drawing = "false";
        maker.dataset.erasing = "false";
        selectedObject = "drawing";
        maker.dataset.selected = "drawing";
        setMobileMode("move");
        setMode("move-mode");
        updateControls();
        updateSelectionBox();
        updateActionAvailability();
        showToast("Handwriting saved");
      }

      function clearDrawing() {
        drawingContext.clearRect(0, 0, drawingLayer.width, drawingLayer.height);
        maker.dataset.hasDrawing = "false";
        maker.dataset.drawing = "false";
        if (selectedObject === "drawing") {
          selectedObject = maker.dataset.hasText === "true" ? "text" : "image";
          maker.dataset.selected = selectedObject;
        }
        if (!hasDesignContent()) {
          setState("empty");
          setMobileMode("upload");
        } else {
          setMobileMode("move");
        }
        updateControls();
        updateSelectionBox();
        commitHistory();
        showToast("Handwriting cleared");
      }

      function openTextInput() {
        setMobileMode("text");
        maker.dataset.textOpen = "true";
        maker.dataset.drawing = "false";
        maker.dataset.erasing = "false";
        setMode("text");
        requestAnimationFrame(() => textInput.focus());
      }

      function addText() {
        const value = textInput.value.trim() || "Custom tattoo";
        textObject.textContent = value;
        maker.dataset.hasText = "true";
        maker.dataset.textOpen = "false";
        maker.dataset.drawing = "false";
        maker.dataset.erasing = "false";
        setMobileMode("move");
        selectedObject = "text";
        maker.dataset.selected = "text";
        applyTextFont();
        setState(maker.dataset.state === "empty" ? "clean" : maker.dataset.state);
        updateControls();
        applyTransform("text");
        commitHistory();
        showToast("Text added to canvas");
      }

      function triggerUpload() {
        setMobileMode("upload");
        setMode("upload");
        maker.dataset.drawing = "false";
        maker.dataset.erasing = "false";
        fileInput.click();
      }

      function readUploadAsDataUrl(file) {
        return new Promise((resolve, reject) => {
          if (file.previewSrc) {
            resolve(file.previewSrc);
            return;
          }
          if (file.type && !file.type.startsWith("image/")) {
            reject(new Error("Unsupported image file"));
            return;
          }
          const reader = new FileReader();
          reader.onload = () => {
            if (typeof reader.result === "string" && reader.result.startsWith("data:image/")) {
              resolve(reader.result);
              return;
            }
            reject(new Error("Image preview data could not be read"));
          };
          reader.onerror = () => reject(new Error("Image file could not be read"));
          reader.readAsDataURL(file);
        });
      }

      function setUploadPreviewSource(src) {
        return new Promise((resolve, reject) => {
          const cleanup = () => {
            uploadPreview.onload = null;
            uploadPreview.onerror = null;
          };
          uploadPreview.onload = () => {
            cleanup();
            if (uploadPreview.naturalWidth > 0 && uploadPreview.naturalHeight > 0) {
              resolve(src);
              return;
            }
            reject(new Error("Image loaded without dimensions"));
          };
          uploadPreview.onerror = () => {
            cleanup();
            reject(new Error("Image preview could not be rendered"));
          };
          uploadPreview.src = src;
          if (uploadPreview.complete && uploadPreview.naturalWidth > 0 && uploadPreview.currentSrc === src) {
            cleanup();
            resolve(src);
          }
        });
      }

      function resetFailedUploadPreview() {
        uploadPreview.onload = null;
        uploadPreview.onerror = null;
        uploadPreview.removeAttribute("src");
        maker.dataset.uploaded = "false";
        maker.dataset.cleaned = "false";
        if (selectedObject === "image") {
          selectedObject = maker.dataset.hasText === "true" ? "text" : maker.dataset.hasDrawing === "true" ? "drawing" : "image";
          maker.dataset.selected = selectedObject;
        }
        if (!hasDesignContent()) {
          setState("empty");
          setMobileMode("upload");
        } else {
          setState("clean");
          setMobileMode("move");
        }
        updateControls();
        updateSelectionBox();
      }

      async function handleUpload(file) {
        if (!file) return;
        const currentUploadRequest = ++uploadRequestId;
        showToast("Preparing image preview...");
        try {
          const url = await readUploadAsDataUrl(file);
          if (currentUploadRequest !== uploadRequestId) return;
          await setUploadPreviewSource(url);
          if (currentUploadRequest !== uploadRequestId) return;
          maker.dataset.uploaded = "true";
          maker.dataset.drawing = "false";
          maker.dataset.erasing = "false";
          maker.dataset.cleaned = "false";
          lastOriginalImageSrc = url;
          syncEditableImageCanvas();
          transforms.image = { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1 };
          selectedObject = "image";
          maker.dataset.selected = "image";
          const name = String(file.name || "").toLowerCase();
          const nextState = /complex|skin|photo|screenshot|low|gray|contrast/.test(name) ? "optimize" : "clean";
          setState(nextState);
          setMobileMode("move");
          updateControls();
          applyTransform("image");
          focusEditorViewport();
          commitHistory();
          showToast("Image uploaded to canvas");
        } catch (error) {
          if (currentUploadRequest !== uploadRequestId) return;
          resetFailedUploadPreview();
          showToast("We could not preview this image. Please try another file.");
        } finally {
          fileInput.value = "";
        }
      }

      function nudge(dx, dy) {
        transforms[selectedObject].x += dx;
        transforms[selectedObject].y += dy;
        applyTransform();
        updateControls();
        commitHistory();
        showToast("Moved selected layer");
      }

      function scaleBy(delta) {
        const current = transforms[selectedObject].scale;
        transforms[selectedObject].scale = clamp(current + delta, 0.25, 2.5);
        applyTransform();
        updateControls();
        commitHistory();
        showToast("Scaled selected layer");
      }

      function toggleFocusCanvas() {
        const enabled = maker.dataset.focus !== "true";
        maker.dataset.focus = enabled ? "true" : "false";
        if (window.innerWidth <= 900) {
          if (enabled && maker.dataset.mobileMode === "size") {
            setMobileMode(hasDesignContent() ? "move" : "upload");
          }
          setMobileDrawer(enabled, { notify: false });
        }
        updateControls();
        syncMakerViewportHeight();
        if (window.innerWidth > 900) {
          showToast(enabled ? "Landscape edit on" : "Landscape edit off");
        }
      }

      function centerSelected() {
        if (!hasDesignContent()) {
          showToast("Add artwork, text, or handwriting before centering");
          return;
        }
        const value = transforms[selectedObject] || transforms.image;
        value.x = 0;
        value.y = 0;
        applyTransform();
        updateControls();
        commitHistory();
        showToast("Centered selected layer");
      }

      function deleteSelected() {
        if (selectedObject === "drawing") {
          clearDrawing();
          return;
        }
        if (selectedObject === "text") {
          textObject.textContent = "";
          maker.dataset.hasText = "false";
          selectedObject = "image";
          maker.dataset.selected = "image";
          if (!hasDesignContent()) setState("empty");
          updateControls();
          updateSelectionBox();
          commitHistory();
          showToast("Text layer deleted");
          return;
        }
        maker.dataset.uploaded = "false";
        maker.dataset.cleaned = "false";
        uploadPreview.removeAttribute("src");
        imageEditCanvas.width = 0;
        imageEditCanvas.height = 0;
        selectedObject = "image";
        maker.dataset.selected = "image";
        setState(maker.dataset.hasText === "true" ? "clean" : "empty");
        updateControls();
        commitHistory();
        showToast("Artwork removed");
      }

      function previewDesign(title = "Design preview", meta = "Transparent PNG draft - " + productMeta()) {
        if (!requireDesignContent("Preview")) return false;
        setMobileMode("review");
        const image = activeImage();
        previewPaper.innerHTML = "";
        if (image && getComputedStyle(image).display !== "none") {
          const clone = image.cloneNode();
          clone.className = "";
          clone.style.cssText = image.style.cssText;
          clone.style.position = "absolute";
          clone.style.left = "50%";
          clone.style.top = "50%";
          clone.style.display = "block";
          clone.style.maxWidth = "70%";
          clone.style.maxHeight = "74%";
          clone.style.objectFit = "contain";
          clone.style.transform = "translate(-50%, -50%) translate(var(--x, 0px), var(--y, 0px)) scale(var(--scale, 1)) rotate(var(--rotate, 0deg))";
          clone.style.transformOrigin = "center";
          previewPaper.appendChild(clone);
        }
        if (maker.dataset.hasDrawing === "true") {
          const drawingClone = new Image();
          drawingClone.src = drawingLayer.toDataURL("image/png");
          drawingClone.alt = "Handwriting layer preview";
          drawingClone.style.cssText = drawingLayer.style.cssText;
          drawingClone.style.position = "absolute";
          drawingClone.style.inset = "0";
          drawingClone.style.display = "block";
          drawingClone.style.width = "100%";
          drawingClone.style.height = "100%";
          drawingClone.style.objectFit = "contain";
          drawingClone.style.transform = "translate(var(--x, 0px), var(--y, 0px)) scale(var(--scale, 1)) rotate(var(--rotate, 0deg))";
          drawingClone.style.transformOrigin = "center";
          previewPaper.appendChild(drawingClone);
        }
        if (maker.dataset.hasText === "true") {
          const textClone = textObject.cloneNode(true);
          textClone.className = "text-object";
          textClone.style.display = "block";
          textClone.style.cssText += textObject.style.cssText;
          previewPaper.appendChild(textClone);
        }
        previewTitle.textContent = title;
        previewMeta.textContent = meta;
        document.body.classList.add("jp-tattoo-maker-modal-open");
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        return true;
      }

      function closePreview() {
        modal.classList.remove("is-open");
        document.body.classList.remove("jp-tattoo-maker-modal-open");
        modal.setAttribute("aria-hidden", "true");
      }

      function saveDraft() {
        if (!requireDesignContent("Save")) return;
        setState("ready");
        commitHistory();
        showToast(`Saved draft for ${productConfig.size.short}`);
      }

      function cartLineItemProperties() {
        const properties = {
          "_Custom design": maker.dataset.cleaned === "true" ? "Background cleaned" : "Saved from custom tool",
          "_Tattoo size": productConfig.size.label,
          "_Print quantity": productConfig.quantity,
          "_Design type": designKind(),
          "_Background": maker.dataset.cleaned === "true" ? "Background cleaned" : (hasImageContent() ? "Original upload" : "No uploaded image"),
          "_Created with": "JUSTPRESS custom tattoo maker"
        };
        if (maker.dataset.hasText === "true") properties["_Text"] = textObject.textContent || textInput.value || "Custom tattoo";
        if (maker.dataset.hasDrawing === "true") properties["_Handwriting"] = "Included";
        if (hasImageContent()) properties["_Artwork"] = "Customer uploaded artwork in custom tool";
        properties["_JP design state"] = JSON.stringify({
          selectedObject,
          cleaned: maker.dataset.cleaned === "true",
          hasImage: hasImageContent(),
          hasText: maker.dataset.hasText === "true",
          hasDrawing: maker.dataset.hasDrawing === "true",
          textFont: selectedTextFont,
          transforms
        }).slice(0, 4000);
        return properties;
      }

      function setCartFeedback(message = "", success = false) {
        if (!cartFeedback) return;
        cartFeedback.textContent = message;
        cartFeedback.classList.toggle("is-success", success);
      }

      function setCartButtonsLoading(loading) {
        cartRequestInFlight = loading;
        document.querySelectorAll('[data-action="cart"]').forEach((button) => {
          button.disabled = loading;
          const isPreviewCartButton = Boolean(button.closest(".preview-foot"));
          if (loading) {
            button.textContent = "Adding...";
          } else {
            button.textContent = isPreviewCartButton && cartAddedForCurrentDesign ? "View cart" : "Add to cart";
          }
        });
      }

      function appendCartProperties(formData, properties) {
        Object.entries(properties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
      }

      function openThemeCart(cartResponse) {
        if (window.ajaxCart && typeof window.ajaxCart.load === "function") {
          if (cartResponse && cartResponse.sections && cartResponse.sections["side-cart"]) {
            window.ajaxCart.load(cartResponse, true);
          } else {
            window.ajaxCart.load(false, true, false, true);
          }
          return true;
        }

        const cartTrigger = document.querySelector('a[data-panel="cart"], button[data-panel="cart"]');
        if (cartTrigger) {
          cartTrigger.click();
          return true;
        }

        if (typeof window.openPanel === "function" && document.getElementById("cart")) {
          window.openPanel("cart");
          return true;
        }

        return false;
      }

      async function refreshThemeCart() {
        try {
          const response = await fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } });
          if (!response.ok) return null;
          const cart = await response.json();
          const count = String(cart.item_count || 0);
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-count').forEach((node) => {
            node.textContent = count;
          });
          document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
          return cart;
        } catch (error) {
          return null;
        }
      }

      async function addDesignToCart() {
        if (cartRequestInFlight) return;
        if (!requireDesignContent("Add to cart")) {
          setCartFeedback("Add artwork or text before adding to cart.");
          return;
        }
        const variant = selectedVariant();
        if (!variant || !variant.id || variant.available === false) {
          setCartFeedback("Choose an available size and print quantity.");
          showToast("This product option is unavailable");
          return;
        }

        setCartButtonsLoading(true);
        setCartFeedback("Adding custom tattoo to cart...");
        try {
          const body = new FormData();
          body.append("id", String(variant.id));
          body.append("quantity", "1");
          body.append("sections", "side-cart");
          appendCartProperties(body, cartLineItemProperties());

          const response = await fetch((window.routes && window.routes.cart_add_url) || "/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/javascript"
            },
            body
          });

          const added = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(added.description || added.message || "Cart add failed");
          }
          if (added.status) throw new Error(added.description || added.message || "Cart add failed");

          const cart = await refreshThemeCart();
          cartAddedForCurrentDesign = true;
          setState("ready");
          setMobileMode("review");
          setCartFeedback("Added to cart" + (cart ? " - " + cart.item_count + " item" + (cart.item_count === 1 ? "" : "s") : ""), true);
          previewTitle.textContent = "Added to cart";
          previewMeta.textContent = productMeta() + " - Custom design saved to cart";
          closePreview();
          const openedThemeCart = openThemeCart(added);
          showToast(openedThemeCart ? "Added to cart" : "Added custom tattoo to cart");
          return added;
        } catch (error) {
          setCartFeedback(error.message || "We could not add this design. Please try again.");
          showToast("Could not add to cart. Please try again.");
        } finally {
          setCartButtonsLoading(false);
        }
      }

      function cartHandoff() {
        if (!requireDesignContent("Add to cart")) {
          setCartFeedback("Add artwork or text before adding to cart.");
          return;
        }
        const variant = selectedVariant();
        if (!variant || !variant.id || variant.available === false) {
          setCartFeedback("Choose an available size and print quantity.");
          showToast("This product option is unavailable");
          return;
        }

        if (modal.classList.contains("is-open")) {
          if (cartAddedForCurrentDesign) {
            window.location.assign("/cart");
            return;
          }
          addDesignToCart();
          return;
        }

        setState("ready");
        commitHistory();
        previewDesign("Review your custom tattoo", productMeta());
        cartAddedForCurrentDesign = false;
        setCartButtonsLoading(false);
        setCartFeedback("Review the preview, then add to cart.");
      }

      async function cleanUploadedArtwork(selectedImage) {
        await loadCutoutEngine();

        if (isCutoutReady()) {
          return window.JPTattooCutout.cleanUploadedArtwork(selectedImage);
        }

        if (shell?.dataset.cutoutEngineSrc) {
          return {
            canvas: null,
            blob: null,
            status: "failed",
            message: "We could not clean this image automatically. Upload a cleaner design or continue manually."
          };
        }

        return {
          canvas: null,
          blob: null,
          status: maker.dataset.state === "warning" ? "reference_or_manual" : "success",
          message: maker.dataset.state === "warning"
            ? "This image is better as a reference. Upload a cleaner design or continue manually."
            : "Background cleaned"
        };
      }

      window.cleanUploadedArtwork = cleanUploadedArtwork;

      function applyCleanedCanvas(result) {
        if (result && result.canvas && result.canvas.toDataURL) {
          copyCanvasToEditableImage(result.canvas);
        }
        maker.dataset.uploaded = "true";
        maker.dataset.cleaned = "true";
        selectedObject = "image";
        applyTransform("image");
        updateControls();
        updateSelectionBox();
      }

      function previewOriginalUpload() {
        if (!lastOriginalImageSrc) {
          showToast("Original image is not available in this session");
          return;
        }
        previewPaper.innerHTML = "";
        const original = new Image();
        original.src = lastOriginalImageSrc;
        original.alt = "Original uploaded artwork preview";
        original.style.cssText = "position:absolute;left:50%;top:50%;display:block;max-width:72%;max-height:76%;object-fit:contain;transform:translate(-50%, -50%);";
        previewPaper.appendChild(original);
        previewTitle.textContent = "Original upload";
        previewMeta.textContent = productMeta() + " - Before cleanup";
        setCartFeedback("Compare with the cleaned preview before ordering.");
        document.body.classList.add("jp-tattoo-maker-modal-open");
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
      }

      function restoreOriginalUpload() {
        if (!lastOriginalImageSrc) {
          showToast("Original image is not available in this session");
          return;
        }
        uploadPreview.onload = () => {
          syncEditableImageCanvas();
          uploadPreview.onload = null;
        };
        uploadPreview.src = lastOriginalImageSrc;
        maker.dataset.cleaned = "false";
        selectedObject = "image";
        setState("optimize");
        updateControls();
        updateSelectionBox();
        commitHistory();
        showToast("Original image restored");
      }

      async function handleCleanBackground() {
        const image = activeImage();
        if (selectedObject !== "image" || !image) {
          showToast("Select an uploaded image to clean the background");
          return;
        }

        lastOriginalImageSrc = image.currentSrc || image.src || lastOriginalImageSrc;
        showToast("Cleaning...");
        const result = await cleanUploadedArtwork(image);

        if (result.status === "success") {
          applyCleanedCanvas(result);
          setState("clean");
          commitHistory();
          showToast(result.message || "Background cleaned");
          setCartFeedback("Background cleaned. Preview the result or use original if needed.", true);
          return;
        }

        if (result.status === "needs_crop") {
          setState("warning");
          commitHistory();
          showToast(result.message || "Some edges may need a quick touch-up.");
          setCartFeedback("Some edges may need a quick touch-up. Adjust crop or continue manually.");
          return;
        }

        if (result.status === "reference_or_manual") {
          setState("warning");
          commitHistory();
          showToast(result.message || "This image is better as a reference. Upload a cleaner design or continue manually.");
          return;
        }

        showToast("Could not clean this image. Upload a cleaner design or continue manually.");
      }

      function pointerPoint(event) {
        return { x: event.clientX, y: event.clientY };
      }

      function gesturePoints() {
        return Array.from(gesturePointers.values()).slice(0, 2);
      }

      function distanceBetween(a, b) {
        return Math.hypot(b.x - a.x, b.y - a.y);
      }

      function angleBetween(a, b) {
        return Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
      }

      function midpointBetween(a, b) {
        return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      }

      function angleDelta(current, start) {
        let delta = current - start;
        while (delta > 180) delta -= 360;
        while (delta < -180) delta += 360;
        return delta;
      }

      function startTouchGesture() {
        const points = gesturePoints();
        if (points.length < 2 || !pointerState) return;
        const type = pointerState.type;
        gestureState = {
          type,
          startDistance: Math.max(1, distanceBetween(points[0], points[1])),
          startAngle: angleBetween(points[0], points[1]),
          startCenter: midpointBetween(points[0], points[1]),
          origin: { ...transforms[type] }
        };
        pointerState.mode = "gesture";
      }

      function releaseGesturePointers() {
        gesturePointers.forEach((_, id) => {
          try {
            if (paper.hasPointerCapture && paper.hasPointerCapture(id)) paper.releasePointerCapture(id);
          } catch (error) {
            // Pointer capture may already be released by the browser.
          }
        });
        gesturePointers.clear();
      }

      function beginCanvasEdit(event) {
        if (event.button !== undefined && event.button !== 0) return;
        if (event.target.closest("button, input, select, textarea")) return;
        if (maker.dataset.drawing === "true") return;
        if (maker.dataset.erasing === "true") {
          beginImageErase(event);
          return;
        }
        if (maker.dataset.state === "empty" && maker.dataset.hasText !== "true") return;

        if (pointerState && hasDesignContent()) {
          gesturePointers.set(event.pointerId, pointerPoint(event));
          try {
            paper.setPointerCapture(event.pointerId);
          } catch (error) {
            // Some mobile browsers release capture during multi-touch transitions.
          }
          if (gesturePointers.size >= 2) startTouchGesture();
          event.preventDefault();
          return;
        }

        const textTarget = event.target.closest(".text-object");
        const imageTarget = event.target.closest(".sample-art");
        const boxTarget = event.target.closest(".selection-box");
        const isScaleHandle = event.target.matches(".scale-handle, .selection-box .handle:nth-child(3)");

        if (textTarget && maker.dataset.hasText === "true") {
          selectObject("text");
        } else if (imageTarget) {
          selectObject("image");
        } else if (!boxTarget) {
          return;
        }

        pointerState = {
          id: event.pointerId,
          mode: isScaleHandle ? "scale" : "drag",
          type: selectedObject,
          startX: event.clientX,
          startY: event.clientY,
          origin: { ...transforms[selectedObject] }
        };
        gesturePointers.clear();
        gesturePointers.set(event.pointerId, pointerPoint(event));
        try {
          paper.setPointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture is best-effort on older mobile browsers.
        }
        event.preventDefault();
      }

      function moveCanvasEdit(event) {
        if (eraserPointer) {
          moveImageErase(event);
          return;
        }
        if (!pointerState) return;

        if (gesturePointers.has(event.pointerId)) {
          gesturePointers.set(event.pointerId, pointerPoint(event));
        }

        if (gestureState && gesturePointers.size >= 2) {
          const points = gesturePoints();
          const value = transforms[gestureState.type];
          const nextDistance = Math.max(1, distanceBetween(points[0], points[1]));
          const nextAngle = angleBetween(points[0], points[1]);
          const nextCenter = midpointBetween(points[0], points[1]);

          value.scale = clamp(gestureState.origin.scale * (nextDistance / gestureState.startDistance), 0.25, 2.5);
          value.rotate = Math.round(gestureState.origin.rotate + angleDelta(nextAngle, gestureState.startAngle));
          value.x = gestureState.origin.x + (nextCenter.x - gestureState.startCenter.x);
          value.y = gestureState.origin.y + (nextCenter.y - gestureState.startCenter.y);

          selectedObject = gestureState.type;
          maker.dataset.selected = selectedObject;
          applyTransform(gestureState.type);
          scheduleControlSync();
          event.preventDefault();
          return;
        }

        if (pointerState.id !== event.pointerId) return;

        const dx = event.clientX - pointerState.startX;
        const dy = event.clientY - pointerState.startY;
        const value = transforms[pointerState.type];

        if (pointerState.mode === "scale") {
          value.scale = clamp(pointerState.origin.scale + ((dx + dy) / 320), 0.25, 2.5);
        } else {
          value.x = pointerState.origin.x + dx;
          value.y = pointerState.origin.y + dy;
        }

        selectedObject = pointerState.type;
        maker.dataset.selected = selectedObject;
        applyTransform(pointerState.type);
        scheduleControlSync();
        event.preventDefault();
      }

      function endCanvasEdit(event) {
        if (eraserPointer) {
          endImageErase(event);
          return;
        }
        if (!pointerState) return;
        if (gestureState && gesturePointers.has(event.pointerId)) {
          releaseGesturePointers();
          gestureState = null;
          pointerState = null;
          commitHistory();
          showToast("Adjusted selected layer");
          return;
        }
        if (pointerState.id !== event.pointerId) return;
        const wasScale = pointerState.mode === "scale";
        const wasGesture = pointerState.mode === "gesture" || Boolean(gestureState);
        gesturePointers.delete(event.pointerId);
        releaseGesturePointers();
        gestureState = null;
        pointerState = null;
        commitHistory();
        showToast(wasGesture ? "Adjusted selected layer" : wasScale ? "Scaled selected layer" : "Moved selected layer");
      }

      function handleAction(action) {
        switch (action) {
          case "toggle-mobile-drawer":
            toggleMobileDrawer();
            break;
          case "undo":
            undoHistory();
            break;
          case "redo":
            redoHistory();
            break;
          case "upload":
            setMobileMode("upload");
            triggerUpload();
            break;
          case "size":
            setMobileMode("size");
            maker.dataset.drawing = "false";
            maker.dataset.erasing = "false";
            setMode("move-mode");
            updateControls();
            break;
          case "text":
            openTextInput();
            break;
          case "add-text":
            addText();
            break;
          case "select-image":
            selectObject("image");
            break;
          case "select-text":
            selectObject("text");
            break;
          case "select-drawing":
            selectObject("drawing");
            break;
          case "draw":
            enableDrawingMode();
            break;
          case "finish-drawing":
            finishDrawing();
            break;
          case "clear-drawing":
            clearDrawing();
            break;
          case "layers":
            updateControls();
            showToast("Layer list is open in the inspector");
            break;
          case "move-mode":
            setMobileMode("move");
            maker.dataset.drawing = "false";
            maker.dataset.erasing = "false";
            setMode("move-mode");
            showToast("Drag the selected layer on the canvas");
            break;
          case "erase-image":
            enableImageEraseMode();
            break;
          case "nudge-up":
            nudge(0, -10);
            break;
          case "nudge-down":
            nudge(0, 10);
            break;
          case "nudge-left":
            nudge(-10, 0);
            break;
          case "nudge-right":
            nudge(10, 0);
            break;
          case "scale-up":
            scaleBy(0.08);
            break;
          case "scale-down":
            scaleBy(-0.08);
            break;
          case "focus-canvas":
            toggleFocusCanvas();
            break;
          case "center-selected":
            centerSelected();
            break;
          case "reset-transform":
            transforms[selectedObject] = { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1 };
            applyTransform();
            updateControls();
            commitHistory();
            showToast("Transform reset");
            break;
          case "delete":
            deleteSelected();
            break;
          case "preview":
            setMobileMode("review");
            previewDesign("Review your custom tattoo", productMeta());
            break;
          case "close-preview":
            closePreview();
            break;
          case "save":
            saveDraft();
            break;
          case "cart":
            cartHandoff();
            break;
          case "size":
            setMobileMode("size");
            updateProductConfig({ notify: true });
            (productSizeSelects.find((select) => select.offsetParent !== null) || productSizeSelects[0])?.focus();
            break;
          case "clean-background":
            handleCleanBackground();
            break;
          case "preview-original":
            previewOriginalUpload();
            break;
          case "restore-original":
            restoreOriginalUpload();
            break;
          case "keep-original":
            setState("ready");
            commitHistory();
            showToast("Original kept for manual review");
            break;
        }
      }

      document.addEventListener("click", (event) => {
        const action = event.target.closest("[data-action]");
        if (action) {
          handleAction(action.dataset.action);
          return;
        }

        const trigger = event.target.closest("[data-state-target]");
        if (!trigger) return;
        setState(trigger.dataset.stateTarget);
      });

      document.querySelector(".paper").addEventListener("click", (event) => {
        if (event.target.closest(".text-object")) selectObject("text");
        else if (event.target.closest(".sample-art")) selectObject("image");
      });

      paper.addEventListener("pointerdown", beginCanvasEdit);
      paper.addEventListener("pointermove", moveCanvasEdit);
      paper.addEventListener("pointerup", endCanvasEdit);
      paper.addEventListener("pointercancel", endCanvasEdit);

      drawingLayer.addEventListener("pointerdown", beginDrawing);
      drawingLayer.addEventListener("pointermove", moveDrawing);
      drawingLayer.addEventListener("pointerup", endDrawing);
      drawingLayer.addEventListener("pointercancel", endDrawing);

      textInput.addEventListener("keydown", (event) => {
        if (event.key === "Enter") addText();
        if (event.key === "Escape") maker.dataset.textOpen = "false";
      });

      textInput.addEventListener("input", () => {
        if (fontPreview) fontPreview.textContent = textInput.value.trim() || "Custom tattoo";
      });

      textFontSelects.forEach((select) => {
        select.addEventListener("change", () => {
          applyTextFont(select.value);
          if (maker.dataset.hasText === "true") {
            commitHistory();
            showToast("Font updated");
          }
        });
      });

      fileInput.addEventListener("change", (event) => handleUpload(event.target.files[0]));

      productSizeSelects.forEach((select) => {
        select.addEventListener("change", () => {
          const nextSize = productSizes.find((size) => size.label === select.value);
          if (!nextSize) return;
          productConfig.size = nextSize;
          updateProductConfig({ notify: true });
        });
      });

      productQuantitySelects.forEach((select) => {
        select.addEventListener("change", () => {
          if (!productQuantities.includes(select.value)) return;
          productConfig.quantity = select.value;
          updateProductConfig({ notify: true });
        });
      });

      document.querySelectorAll(".control-scale").forEach((input) => {
        input.addEventListener("input", () => {
          transforms[selectedObject].scale = Number(input.value) / 100;
          applyTransform();
          updateControls();
        });
        input.addEventListener("change", () => {
          commitHistory();
          showToast("Scaled selected layer");
        });
      });

      document.querySelectorAll(".control-rotate").forEach((input) => {
        input.addEventListener("input", () => {
          transforms[selectedObject].rotate = Number(input.value);
          applyTransform();
          updateControls();
        });
        input.addEventListener("change", () => {
          commitHistory();
          showToast("Rotated selected layer");
        });
      });

      document.querySelectorAll(".control-opacity").forEach((input) => {
        input.addEventListener("input", () => {
          transforms[selectedObject].opacity = Number(input.value) / 100;
          applyTransform();
          updateControls();
        });
        input.addEventListener("change", () => {
          commitHistory();
          showToast("Adjusted selected layer");
        });
      });

      document.querySelectorAll(".control-eraser").forEach((input) => {
        input.addEventListener("input", () => {
          eraserBrush.size = Number(input.value);
          updateControls();
        });
      });

      brushSizeInputs.forEach((input) => {
        input.addEventListener("input", () => {
          setDrawingBrushSize(input.value);
        });
        input.addEventListener("change", () => {
          showToast(`Brush stroke ${drawingBrush.size}px`);
        });
      });

      brushOptions.forEach((button) => {
        button.addEventListener("click", () => {
          setDrawingBrush(button.dataset.brush, { notify: true });
        });
      });

      modal.addEventListener("click", (event) => {
        if (event.target === modal) closePreview();
      });

      window.addEventListener("resize", resizeDrawingLayer);
      if ("ResizeObserver" in window) {
        new ResizeObserver(resizeDrawingLayer).observe(paper);
      }

      fillProductOptions();
      updateProductConfig();
      applyTextFont();
      resizeDrawingLayer();
      applyTransform("image");
      applyTransform("text");
      applyTransform("drawing");
      updateControls();
      updateSelectionBox();
      updateMobileActionState();
      updateMobileDrawerToggle();
      scheduleDrawerCue();
      updateActionAvailability();
      commitHistory();

      window.layoutV26 = {
        addText,
        applyTextFont,
        cartHandoff,
        centerSelected,
        cleanUploadedArtwork,
        clearDrawing,
        closePreview,
        commitHistory,
        enableImageEraseMode,
        enableDrawingMode,
        handleAction,
        handleCleanBackground,
        handleUpload,
        previewDesign,
        productConfig,
        productSizes,
        productUrl,
        productVariants,
        saveDraft,
        selectObject,
        setMobileDrawer,
        setState,
        setDrawingBrush,
        setDrawingBrushSize,
        toggleMobileDrawer,
        undoHistory,
        redoHistory,
        updateProductConfig
      };
      window.layoutV25 = window.layoutV26;
      window.layoutV24 = window.layoutV26;
    
})();
